<script>
  import { playerState } from '../js/state.js';
  import { requestPlayVideo, requestPauseVideo, requestJumpToLiveVideo } from '../js/actions.js';

  import {
    HOW_DELAYED_IS_TOO_DELAYED,
    DELAY_OK,
    DELAY_BEHIND,
    DELAY_AHEAD,
  } from '../js/constants.js';

  import {
    PLAYER_DELAY_AHEAD_NOTICE,
    PLAYER_DELAY_BEHIND_NOTICE,
    PLAYER_DELAY_CATCH_UP,
  } from '../js/l10n/en_US.js';

  function catchUp() {
    requestJumpToLiveVideo();
    setTimeout(() => {
      requestPlayVideo();
    }, 300);
  }
</script>

<style>
  .player-delay-notice {
    padding: 5px;
    color: white;
    background: rgba(0, 0, 0, 0.7);
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 50;
  }

  .player-delay-notice span {
    cursor: pointer;
    text-decoration: underline;
  }
</style>

<div>
  {#if $playerState.delayStatus != DELAY_OK}
    <div class="player-delay-notice">
      {$playerState.delayStatus === DELAY_AHEAD ? PLAYER_DELAY_AHEAD_NOTICE : PLAYER_DELAY_BEHIND_NOTICE}
      <span on:click|preventDefault={catchUp}>{PLAYER_DELAY_CATCH_UP}</span>
    </div>
  {/if}
</div>
